// Lesson 2: Menyebutkan Asal - Vocabulary Data
export interface Word {
    id: number;
    batak: string;
    latin: string[];
    indonesia: string;
    syllable_mapping: Array<{
        batak_char: string;
        latin: string;
    }>;
}

// Vocabulary for Lesson 2: Menyebutkan Asal (Stating Origin)
export const unit1Lesson2VocabularyBank: Word[] = [
    {
        id: 201,
        batak: "ᯀᯘᯇ",
        latin: ["a", "sal"],
        indonesia: "Asal",
        syllable_mapping: [
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯘᯇ", latin: "sal" }
        ]
    },
    {
        id: 202,
        batak: "ᯘᯀᯤ ᯑᯬ",
        latin: ["sai", "do"],
        indonesia: "Dari mana",
        syllable_mapping: [
            { batak_char: "ᯘᯀᯤ", latin: "sai" },
            { batak_char: "ᯑᯬ", latin: "do" }
        ]
    },
    {
        id: 203,
        batak: "ᯀᯮᯑᯬ",
        latin: ["au", "do"],
        indonesia: "Saya dari",
        syllable_mapping: [
            { batak_char: "ᯀᯮ", latin: "au" },
            { batak_char: "ᯑᯬ", latin: "do" },
        ]
    },
    {
        id: 204,
        batak: "ᯔᯉ",
        latin: ["me", "dan"],
        indonesia: "Medan",
        syllable_mapping: [
            { batak_char: "ᯔ", latin: "me" },
            { batak_char: "ᯉ", latin: "dan" }
        ]
    },
    {
        id: 205,
        batak: "ᯂᯮᯖ",
        latin: ["hu", "ta"],
        indonesia: "Kampung",
        syllable_mapping: [
            { batak_char: "ᯂᯮ", latin: "hu" },
            { batak_char: "ᯖ", latin: "ta" }
        ]
    },
    {
        id: 206,
        batak: "ᯅᯝᯪᯎ",
        latin: ["ba", "li", "ge"],
        indonesia: "Balige",
        syllable_mapping: [
            { batak_char: "ᯅ", latin: "ba" },
            { batak_char: "ᯝᯪ", latin: "li" },
            { batak_char: "ᯎ", latin: "ge" }
        ]
    },
    {
        id: 207,
        batak: "ᯇᯬᯒᯘ",
        latin: ["por", "se", "a"],
        indonesia: "Porsea",
        syllable_mapping: [
            { batak_char: "ᯇᯬᯒ", latin: "por" },
            { batak_char: "ᯘ", latin: "se" },
            { batak_char: "ᯀ", latin: "a" }
        ]
    },
    {
        id: 208,
        batak: "ᯖᯀᯒᯮᯖᯮᯰ",
        latin: ["ta", "ru", "tung"],
        indonesia: "Tarutung",
        syllable_mapping: [
            { batak_char: "ᯖᯀ", latin: "ta" },
            { batak_char: "ᯒᯮ", latin: "ru" },
            { batak_char: "ᯖᯮᯰ", latin: "tung" }
        ]
    },
    {
        id: 998,
        batak: "?",
        latin: ["?"],
        indonesia: "?",
        syllable_mapping: [{ batak_char: "?", latin: "?" }],
    },
    {
		id: 999,
		batak: "",
		latin: ["."],
		indonesia: "",
		syllable_mapping: [{ batak_char: "", latin: "-" }],
	}
];
// ᯉᯎᯒ
// ᯖᯉᯬ ᯑᯔᯩ
// Extended word bank for sentence composition
export const unit1Lesson2ExtendedWordBank: Word[] = [
    ...unit1Lesson2VocabularyBank,
    // Include some words from lesson 1 for continuity
    {
        id: 105,
        batak: "ᯀᯮ",
        latin: ["au"],
        indonesia: "Saya",
        syllable_mapping: [
            { batak_char: "ᯀᯮ", latin: "au" }
        ]
    },
    {
        id: 106,
        batak: "ᯂᯬ",
        latin: ["ho"],
        indonesia: "Kamu",
        syllable_mapping: [
            { batak_char: "ᯂᯬ", latin: "ho" }
        ]
    },
    {
        id: 107,
        batak: "ᯤᯀ",
        latin: ["i", "a"],
        indonesia: "Dia",
        syllable_mapping: [
            { batak_char: "ᯤ", latin: "i" },
            { batak_char: "ᯀ", latin: "a" }
        ]
    },
    {
        id: 104,
        batak: "ᯀᯍ",
        latin: ["a", "ha"],
        indonesia: "Aha (Siapa)",
        syllable_mapping: [
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯍ", latin: "ha" }
        ]
    },
    {
        id: 209,
        batak: "ᯑᯬ",
        latin: ["do"],
        indonesia: "dari",
        syllable_mapping: [
            { batak_char: "ᯑᯬ", latin: "do" }
        ]
    },
    {
        id: 210,
        batak: "ᯖᯉᯬ",
        latin: ["ta", "no"],
        indonesia: "Tanah",
        syllable_mapping: [
            { batak_char: "ᯖ", latin: "ta" },
            { batak_char: "ᯉ", latin: "no" }
        ]
    },
    {
        id: 211,
        batak: "ᯑᯔᯩ",
        latin: ["da", "me"],
        indonesia: "Damai",
        syllable_mapping: [
            { batak_char: "ᯑ", latin: "da" },
            { batak_char: "ᯔ", latin: "me" }
        ]
    },
    {
        id: 212,
        batak: "ᯉᯎᯒ",
        latin: ["na", "ga", "ra"],
        indonesia: "Negara",
        syllable_mapping: [
            { batak_char: "ᯉ", latin: "na" },
            { batak_char: "ᯎ", latin: "ga" },
            { batak_char: "ᯒ", latin: "ra" }
        ]
    },
    {
        id: 213,
        batak: "ᯔᯒᯅᯬᯉ",
        latin: ["ma", "ra", "bo", "na"],
        indonesia: "Berasal",
        syllable_mapping: [
            { batak_char: "ᯔ", latin: "ma" },
            { batak_char: "ᯒ", latin: "ra" },
            { batak_char: "ᯅᯬ", latin: "bo" },
            { batak_char: "ᯉ", latin: "na" }
        ]
    },
    {
        id: 214,
        batak: "ᯔᯉᯰ",
        latin: ["ma", "nang"],
        indonesia: "apakah",
        syllable_mapping: [
            { batak_char: "ᯔ", latin: "ma" },
            { batak_char: "ᯉ", latin: "nang" }
        ]
    },
    {
        id: 113,
        batak: "ᯄᯤᯑᯬ",
        latin: ["ka", "i", "do"],
        indonesia: "Kaido",
        syllable_mapping: [
            { batak_char: "ᯄ", latin: "ka" },
            { batak_char: "ᯤ", latin: "i" },
            { batak_char: "ᯑᯬ", latin: "do" }
        ]
    }
];

// Helper function to create word dictionary
export const createUnit1Lesson2WordDict = (wordBank: Word[]) => {
    return Object.fromEntries(wordBank.map((w) => [w.id, w]));
};
